import { flatten, fromPairs, isEmpty, map, pick, pipe, toPairs } from 'ramda';
import { CONFIG_ITEMS, ALL_LIMIT_TYPES, LIMITS_WITHOUT_TYPES } from './constants';

export const parseConfiguration = pipe(
    pick(CONFIG_ITEMS),
    toPairs,
    map(([name, limits]) => {
        const type = LIMITS_WITHOUT_TYPES[name];

        return type != null && !isEmpty(limits)
            ? { ...limits[0], type }
            : limits;
    }),
    flatten,
    map(({ type, ...limit }) => [ALL_LIMIT_TYPES[type], limit]),
    fromPairs
);
